import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltFour12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconStackHorizontalAltFour12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.667 6.033a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m1 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m1.777.334a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667m0 1a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M7.89 6.033a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m1 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m2.111 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m1 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltFour12);
